var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('public-page',[_c('div',{staticClass:"relaxtion-protocol"},[_c('relaxation-protocol-background-card'),_c('relaxation-protocol-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }